<!-- WebGL settings modal -->
<ng-template #webGLSettings let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title" translate>WebGL settings</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <label><span translate>Storage Bucket</span></label>
        <input type="url" class="form-control" placeholder="https://example.com">
      </div>
      <div class="form-group">
        <label><span translate>Path to Build Directory</span></label>
        <input type="text" class="form-control" placeholder="path/example">
      </div>
      <div class="form-group form-check mb-0">
        <input type="checkbox" class="form-check-input" id="exampleCheck1">
        <label class="form-check-label" for="exampleCheck1">Enable data live streaming</label>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <div class="modal-footer-inner">
      <div class="row align-items-center flex-fill">
        <div class="col">
          <small class="text-muted" translate>* Indicates required field</small>
        </div>
        <div class="col-auto">
          <button type="button" class="btn btn-outline-primary mr-2" (click)="modal.dismiss()">
            <span translate>Cancel</span>
          </button>
          <button type="submit" class="btn btn-primary" (click)="modal.close()">
            <span translate>Save</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>